import { Component, ViewEncapsulation } from '@angular/core';
import { SharedModule } from '../../../shared-module';
import { DocumentService } from '../../../../core/services/document.service';

@Component({
  selector: 'app-ad-blocker-detection',
  imports: [SharedModule],
  templateUrl: './ad-blocker-detection.component.html',
  styleUrl: './ad-blocker-detection.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class AdBlockerDetectionComponent {
  constructor(public documentService: DocumentService) {
    //سي
  }
  //   init(): void {
  //   this.adsBlocked((isBlocked: boolean) => {
  //     if (isBlocked) {
  //       document.getElementById("ads-blocked")?.classList.remove("hidden");
  //       const examplePage = document.querySelector(".example-page") as HTMLElement;
  //       if (examplePage) {
  //         examplePage.style.filter = "blur(8px)";
  //       }
  //     } else {
  //       console.log("Ad-blocker Enabled: " + isBlocked);
  //     }
  //   });
  // }
  //   adsBlocked(callback: (isBlocked: boolean) => void): void {
  //   const request = new Request(
  //     "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js",
  //     { method: "HEAD", mode: "no-cors" }
  //   );
  //   fetch(request)
  //     .then((response) => {
  //       console.log(response);
  //       callback(false);
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //       callback(true);
  //     });
  // }
  // setTimeout(() => {
  //   init();
  // }, 3000);
  // /* Code for close button of popup - you can set your own functionality */
  // // Adding event listeners for close buttons
  // document.querySelectorAll(".adblock-close, .btn").forEach((element) => {
  //   element.addEventListener("click", () => {
  //     const adsBlockedElement = document.getElementById("ads-blocked");
  //     if (adsBlockedElement) {
  //       adsBlockedElement.classList.add("hidden");
  //     }
  //     const examplePage = document.querySelector(".example-page") as HTMLElement;
  //     if (examplePage) {
  //       examplePage.style.filter = "blur(0px)";
  //     }
  //   });

  // });
}
